import React, {useEffect, useState} from "react";
import {fetchFriendRequests, fetchFriends, handleFriendRequest, sendFriendRequest} from "../clients/FriendClient"
import {FormField} from "../Views/MyProfile";
import AcceptDenyModal from "./AcceptDenyModal";
import PlusSymbol from "./svg/PlusSymbol";
import SendFriendRequestModal from "./SendFriendRequestModal";
import {useNavigate} from "react-router-dom";
import CreateGameModal from "./CreateGameModal";
import UserLink from "./UserLink";

const FriendModal = ({friend, closeModal}) => {
    const navigate = useNavigate();
    const [showCreateModal, setShowCreateModal] = useState(false)

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                closeModal()
            }
        }

        window.addEventListener("keydown", handleEscape)

        return () => window.removeEventListener("keydown", handleEscape)
    }, [])

    return (
        <div>
            <div style={{position: "fixed", top: "0", left: "0", width: "100vw", height: "100vh", zIndex: "998"}}
                 onClick={closeModal}></div>
            <div className="modal-content"
                 style={{
                     width: "12rem",
                     position: "absolute",
                     maxWidth: "20rem",
                     zIndex: "999",
                     height: "fit-content",
                     display: "flex",
                     flexDirection: "column",
                     justifyContent: "space-between"
                 }}>
                <div style={{alignSelf: "flex-start"}}>
                    <div style={{position: "relative"}}>
                        <img src={"/person.png"} alt={"A profile picture"} style={{width: "2rem"}}/>
                        {friend.isActive && <div style={{position: "absolute", right: "0.95rem", bottom: "0.3rem"}}><Circle/></div>}
                    </div>

                    <UserLink user={{username: friend.friendName, isActualUser: true}} style={{marginTop: "0"}}/>
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    <p style={{fontSize: "0.6rem", fontStyle: "italic"}}>Friends
                        since: {new Date(friend.friendSince).toLocaleDateString('en-GB')}</p>
                    <div style={{marginBottom: "-0.15rem"}}>
                        <img src={"/chat.png"} alt={"A chat icon"} className="icon-style"
                             onClick={() => navigate(`/messages/${friend.friendName}`)}
                             style={{marginRight: "0.2rem", marginBottom: "-0.07rem", height: "1rem"}}/>
                        <img src={"/play.png"} alt={"A play icon"} className="icon-style"
                             onClick={() => setShowCreateModal(true)}
                             style={{height: "1rem"}}/>
                    </div>
                    <CreateGameModal
                        showCreateModal={showCreateModal}
                        closeModal={() => setShowCreateModal(false)}
                        friendName={friend.friendName}
                    />
                </div>
            </div>
        </div>

    )
}

const Circle = ({color, size}) => {
    size ??= "0.5rem"
    color ??= "#63f542"

    return (
        <div style={{backgroundColor: color, borderRadius: "50%", width: size, height: size}}></div>
    )
}

//We can move this to its own file, if we ever think it should exist outside this component as well
const Friend = ({friend, selectedFriend, selectFriend}) => {
    const isSelected = friend.friendName === selectedFriend.friendName;


    return (
        <div style={{position: "relative"}}>
            {isSelected && <FriendModal friend={friend} closeModal={() => selectFriend({})}/>}
            <div style={{cursor: "pointer", position: "relative"}} onClick={() => selectFriend(friend)}>
                {/* TODO add custom profile pictures at some point*/}
                <img src={"/person.png"} alt={"A profile picture"} style={{width: "100%"}}/>
                {friend.isActive &&
                    <div style={{position: "absolute", zIndex: "5", right: "0.25rem", bottom: "0.4rem"}}><Circle/></div>}
            </div>
        </div>

    )
}

const FriendRequest = ({friendRequest, acceptDenyCallback}) => {
    //Be careful about changing userlink here. As the component is wrapped in a paragraph in the AcceptDenyModal
    //If it is changed, then you may have to stop using AcceptDenyModal for friend requests
    const friendLink = <UserLink user={{username: friendRequest.inviterName, isActualUser: true}}
                                 style={{marginTop: "0", marginBottom: "0"}}/>


    return <AcceptDenyModal statement={friendLink} acceptCallback={() => acceptDenyCallback(true)}
                            denyCallback={() => acceptDenyCallback(false)} style={{
        padding: "0",
        justifyContent: "space-between",
        paddingLeft: "0.5rem",
        paddingRight: "0.5rem",
        marginTop: "0.2rem",
        border: "1px solid #ddd"
    }}/>
}


const FriendColumn = () => {
    const [friends, setFriends] = useState([])
    const [friendRequests, setFriendRequests] = useState([])
    const [errorMessage, setErrorMessage] = useState(null)
    const [successMessage, setSuccessMessage] = useState(null)
    const [selectedFriend, setSelectedFriend] = useState({})

    const [showRequestModal, setShowRequestModal] = useState(false)

    useEffect(() => {
        getFriendRequests();
        getFriends();
    }, []);

    const handleError = (error) => {
        setErrorMessage(error.response?.data?.message || error.message)
        setSuccessMessage(null)
    }

    const showSuccessMessage = (successMessage) => {
        setSuccessMessage(successMessage);
        setErrorMessage(null)
    }

    const getFriendRequests = () => {
        fetchFriendRequests()
            .then(setFriendRequests)
            .catch(handleError)
    }

    const getFriends = () => {
        fetchFriends()
            .then(setFriends)
            .catch(handleError)

    }

    const acceptDenyFriendRequest = (friendRequest, accepted) => {
        handleFriendRequest(friendRequest.inviterId, accepted)
            .then(() => {
                accepted ? showSuccessMessage("You are now friends") :
                    showSuccessMessage("Friendship successfully denied");
                setFriendRequests(friendRequests => friendRequests.filter(request => request.inviterId !== friendRequest.inviterId))
            })
            .catch(handleError)
    }

    return (<div style={{
        display: "flex",
        flexDirection: "column",
        padding: "0.5rem",
        border: "solid 2px #ccc",
        marginTop: "1.2rem",
        fontSize: "0.7rem",
        fontWeight: "600",
        color: "#666",
        width: "16rem",
        alignItems: "center"
    }}>
        <p style={{fontSize: "1rem", fontWeight: "700", marginBottom: "0"}}>Friends</p>
        {/*Friend overview */}
        {friends.length > 0 ? <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                minHeight: "0",
                gridAutoRows: '1 fr',
                width: "90%"
            }}>
                {friends.map((friend) => <Friend friend={friend} selectedFriend={selectedFriend}
                                                 selectFriend={(friend) => setSelectedFriend(friend)}/>)} </div> :
            <p style={{fontStyle: "italic", fontWeight: "500"}}>No Friends To Show</p>}

        {/* Friend requests*/}
        <div>
            <p style={{fontSize: "1rem", fontWeight: "700", marginBottom: "0"}}>Friend Requests</p>
            {friendRequests.length > 0 ?
                friendRequests.map((friendRequest) => <FriendRequest friendRequest={friendRequest}
                                                                     acceptDenyCallback={(accepted) => acceptDenyFriendRequest(friendRequest, accepted)}/>) :
                <p style={{fontStyle: "italic", fontWeight: "500"}}>No Pending Friend Requests</p>}
        </div>
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "auto",
            position: "relative"
        }}>

            <div>
                {showRequestModal && <SendFriendRequestModal successCallback={() => {
                    setSuccessMessage("Friend Request Sent");
                    setShowRequestModal(false)
                }}
                                                             closeCallback={() => setShowRequestModal(false)}/>}
                <button onClick={() => setShowRequestModal(true)} style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "0.5rem",
                    padding: "0.2rem"
                }}>
                    <PlusSymbol color="#fff" size="1rem" style={{marginRight: "0.2rem"}}/>
                    <p style={{margin: "0", paddingRight: "0.5rem"}}>Add Friend</p>
                </button>
            </div>

        </div>
        {successMessage && <div className="info-message success"
                                style={{width: "fit-content", padding: "1rem", marginTop: "0.5rem"}}>
            {successMessage}
        </div>}
        {errorMessage && <div className="info-message error"
                              style={{width: "fit-content", padding: "1rem", marginTop: "0.5rem"}}>
            {errorMessage}
        </div>}
    </div>)
}

export default FriendColumn;